function About(){
    return (
        <>
        <h1>About Page</h1>
        </>
    );
}
export default About;